import { useEffect, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

/**
 * La scelta di un cliente, con la ricerca per nome o telefono. Mostra solo i
 * clienti che chi guarda vede: la lista viene da /crm/clienti, cioè dalla RLS.
 * La usano il nuovo appuntamento (Calendario) e l'aggancio di una conversazione
 * (Messaggi).
 */
export default function SceltaCliente({ valore, onScegli, testId, segnaposto = "Scegli il cliente" }) {
  const [aperto, setAperto] = useState(false);
  const [clienti, setClienti] = useState([]);
  useEffect(() => {
    api.get("/crm/clienti").then((r) => setClienti(r.data?.righe || [])).catch(() => setClienti([]));
  }, []);
  const scelto = clienti.find((c) => c.id === valore);
  return (
    <Popover open={aperto} onOpenChange={setAperto}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={aperto}
          className="w-full justify-between font-normal"
          data-testid={testId}
        >
          <span className={cn("truncate", !scelto && "text-muted-foreground")}>{scelto ? scelto.nome : segnaposto}</span>
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] min-w-64 p-0" align="start">
        <Command>
          <CommandInput placeholder="Nome o telefono" data-testid={testId ? `${testId}-cerca` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun cliente. Aggiungilo prima da Clienti.</CommandEmpty>
            {clienti.map((c) => (
              <CommandItem
                key={c.id}
                value={`${c.nome} ${c.telefono || ""} ${c.id}`}
                onSelect={() => {
                  onScegli(c);
                  setAperto(false);
                }}
              >
                <Check className={cn("h-4 w-4", c.id === valore ? "opacity-100" : "opacity-0")} />
                <span className="truncate">{c.nome}</span>
                {c.telefono ? <span className="ml-auto text-xs text-muted-foreground">{c.telefono}</span> : null}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
